/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Salary_TitleInputs */

const en_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salary Intelligence`)
};

const de_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gehaltsintelligenz`)
};

const fr_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligence salariale`)
};

const es_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencia salarial`)
};

const it_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intelligenza salariale`)
};

const nl_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salarisintelligentie`)
};

const pl_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inteligencja wynagrodzeń`)
};

const fi_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Palkkatieto`)
};

const da_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lønoplysninger`)
};

const sv_salary_title = /** @type {(inputs: Salary_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Löneinformation`)
};

/**
* | output |
* | --- |
* | "Salary Intelligence" |
*
* @param {Salary_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const salary_title = /** @type {((inputs?: Salary_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Salary_TitleInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_salary_title(inputs)
	if (locale === "fr") return fr_salary_title(inputs)
	if (locale === "es") return es_salary_title(inputs)
	if (locale === "it") return it_salary_title(inputs)
	if (locale === "nl") return nl_salary_title(inputs)
	if (locale === "pl") return pl_salary_title(inputs)
	if (locale === "fi") return fi_salary_title(inputs)
	if (locale === "da") return da_salary_title(inputs)
	if (locale === "sv") return sv_salary_title(inputs)
	return en_salary_title(inputs)
});